// src/components/HomepageComponents/ContentArea.js
import React from 'react';

export default function ContentArea({
  children,
  className = '',
  containerClassName = 'max-w-7xl mx-auto',
  padded = true,
  title,
  subtitle,
}) {
  return (
    <main className={`${padded ? 'px-4 sm:px-8 md:px-12 lg:px-24 xl:px-[15%]' : ''} ${className}`}>
      <div className={containerClassName}>
        {(title || subtitle) && (
          <header className="py-8 md:py-10">
            {title && <h1 className="text-2xl md:text-4xl font-extrabold tracking-tight">{title}</h1>}
            {subtitle && <p className="mt-2 text-gray-600 text-base md:text-lg">{subtitle}</p>}
          </header>
        )}
        {children}
      </div>
    </main>
  );
}
